import ProgressIcon from './ProgressIcon'

import './Progress.scss'

export default function Progress({ currentIndex, mode }) {
  return (
    <div
      className={`c-progress ${mode === 'free' ? '-is-visible' : ''}`}
    >
      {currentIndex > 0 && <ProgressIcon currentIndex={currentIndex} />}
    </div>
  )
}
